import React from 'react';
import { Lightbulb, ArrowRight, Eye } from 'lucide-react';

interface GameControlsProps {
  hintsUsed: number;
  isWon: boolean;
  isRevealed: boolean;
  onAskHint: () => void;
  onReveal: () => void;
  onNextPhrase: () => void;
}

export const GameControls: React.FC<GameControlsProps> = ({
  hintsUsed,
  isWon,
  isRevealed,
  onAskHint,
  onReveal,
  onNextPhrase,
}) => {
  return (
    <div className="w-full max-w-2xl flex items-center justify-center gap-2.5 my-2">
      {/* Hint Button (Fills a single blank slot) */}
      {!isWon && !isRevealed && (
        <button
          onClick={onAskHint}
          className="py-2.5 px-4 rounded-xl font-bold text-xs sm:text-sm bg-gradient-to-r from-amber-600 to-amber-500 hover:from-amber-500 hover:to-amber-400 text-white shadow-md shadow-amber-500/20 flex items-center gap-2 transition-all transform hover:-translate-y-0.5 active:scale-95"
          title="Fill in a single letter blank slot"
        >
          <Lightbulb className="w-4 h-4 fill-amber-300 text-amber-100 animate-pulse" />
          <span>Ask for Hint</span>
          {hintsUsed > 0 && (
            <span className="bg-amber-800/60 px-1.5 py-0.5 rounded text-[10px]">
              ({hintsUsed})
            </span>
          )}
        </button>
      )}

      {/* Reveal / Give Up Button */}
      {!isWon && !isRevealed && (
        <button
          onClick={onReveal}
          className="py-2.5 px-4 rounded-xl font-bold text-xs sm:text-sm bg-slate-800 hover:bg-slate-700 text-slate-300 border border-slate-700 flex items-center gap-2 transition-all active:scale-95"
          title="Give up and reveal the phrase"
        >
          <Eye className="w-4 h-4 text-slate-400" />
          <span>Give Up</span>
        </button>
      )}

      {/* Next Phrase Button */}
      <button
        onClick={onNextPhrase}
        className={`py-2.5 px-5 rounded-xl font-bold text-xs sm:text-sm flex items-center gap-2 transition-all transform hover:-translate-y-0.5 active:scale-95 shadow-md ${
          isWon || isRevealed
            ? 'bg-gradient-to-r from-indigo-600 to-purple-600 text-white shadow-indigo-500/25 ring-2 ring-indigo-400/50 animate-bounce-short'
            : 'bg-slate-800 hover:bg-slate-700 text-indigo-300 border border-indigo-500/40'
        }`}
        title="Load a new random phrase"
      >
        <span>{isWon || isRevealed ? 'Next Phrase' : 'Skip Phrase'}</span>
        <ArrowRight className="w-4 h-4" />
      </button>
    </div>
  );
};
